
import { Component, Vue } from 'vue-property-decorator';

import config from '@/config';
import HomeIntro from '@/components/Home/HomeIntro.vue';
import OfferShow from '@/components/Home/OfferShow.vue';
import PartnersIntro from '@/components/Home/PartnersIntro.vue';

@Component({
  components: {
    HomeIntro,
    OfferShow,
    PartnersIntro,
  },
})
export default class Home extends Vue {
  get platform() {
    return this.$store.getters['platform/getPlatform'];
  }

  get compShowStickers() {
    return !this.platform.style.hideStickers;
  }

  get compHeaderImage() {
    const image = this.platform.style.headerImage;
    if (!image) {
      return '';
    }
    const headerImage = `${config.apiUrl}/api${image}`;
    return `background-image: url(${headerImage});`;
  }

  get showSecondBlockImage(): boolean {
    return Boolean(this.platform.style.secondBlockImage);
  }

  get secondBlockImage(): string {
    return `${config.apiUrl}/api${this.platform.style.secondBlockImage}`;
  }
}
